:host {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;

    *,
    *::after,
    *::before {
        box-sizing: inherit;
    }

    img {
        display: block;
        width: 100%;
    }

    .ti-media-gallery-primary-image {
        user-select: none; //prevent selection on double click on Chrome
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        border: 1px solid;
        border-color: $pl-border-color-primary;

        ti-image {
            width: 100%;
            cursor: zoom-in;
        }

        // to display zoom icon in bottom right corner
        &::after {
            position: absolute;
            bottom: 0px;
            right: 0px;
            width: 32px;
            height: 32px;
            content: '';
            border: inherit;
            border-bottom: 0;
            border-right: 0;
            background-image: url('https://www.ti.com/assets/icons/ti_icons-actions/zoom-in.svg');
            background-position: 4px 4.5px;
            background-size: 24px;
            background-repeat: no-repeat;
            background-color: $polaris-palette-white;
            pointer-events: none;
            box-sizing: border-box;
        }

        :is(.ti-media-gallery-button-left, .ti-media-gallery-button-right) {
            visibility: hidden;
        }

        &:is(:hover, :focus-within) :is(.ti-media-gallery-button-left, .ti-media-gallery-button-right) {
            visibility: visible;
            cursor: pointer;
        }
    }

    :is(.ti-media-gallery-button-left, .ti-media-gallery-button-right) {
        position: absolute;
        z-index: 2;
        transition: all 150ms;
        border: 0;
        margin: 0;
        padding: 0;
        background-color: transparent;

        ti-svg-icon  {
            filter: drop-shadow(0px 0px 1px rgba(255, 255, 255, .6));
        }

        &.ti-media-gallery-button-disabled {
            cursor: none;
            pointer-events: none;
            opacity: 0.5;

            ti-svg-icon {
                --ti-svg-icon-fill-color: #{$pl-element-color-disabled};
            }
        }
    }

    .ti-media-gallery-button-right {
        right: 0;
    }

    .ti-media-gallery-caption {
        padding: $polaris-space-4 0;
        font-size: $polaris-font-size-1;
        border-bottom: 1px solid $pl-divider-color-secondary;
    }

    .ti-media-gallery-dialog-caption {
        padding-top: $polaris-space-4;
        font-size: $polaris-font-size-1;
        text-align: center;
    }

    .ti-media-gallery-thumbnails {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: $polaris-space-2;
        margin-top:$polaris-space-2;

        @include mix-for-sizes-down(phone) {
            display: inline;
        }
    }

    .ti-media-gallery-thumbnails-item {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0;

        border: 1px solid;
        border-color: $pl-border-color-primary;
        cursor: pointer;
        animation: carousel-fade-in $polaris-animation-timing-fadeIn $polaris-animation-easing-smooth;
        text-align: center;
        color: $polaris-palette-grey5;
        font-size: $pl-text-color-accent-contrast;
        background-color: $pl-container-background-color-primary;
        opacity: 1;
        transition: opacity $polaris-animation-timing-fadeIn $polaris-animation-easing-smooth;

        &.is-hidden {
            display: none;
        }

        &.ti-media-gallery-thumbnails-item-is-active {
            border-color: $pl-border-color-accent;
        }

        &.ti-media-gallery-thumbnails-item-video::before {
            @extend %video-playbutton;
            left: calc(50% - #{$polaris-space-3});
            top: calc(50% - #{$polaris-space-3});
            width: $polaris-space-6;
            height: $polaris-space-6;
        }

        .ti-media-gallery-thumbnails-item-video-is-loading {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .ti-media-gallery-bullet-list {
        width: 100%;
        padding-top: 1rem;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    .ti-media-gallery-bullet {
        width: 0.5rem;
        height: 0.5rem;
        margin: 0 0.5rem 0.5rem;
        border-radius: 50%;
        background-color: $pl-element-color-secondary;
        content: '';

        &:hover {
            cursor: pointer;
        }

        &.ti-media-gallery-bullet-is-active {
            background-color: $pl-element-color-primary;
        }
    }

    // "Play icon" indicating that bullet represents a video
    .ti-media-gallery-bullet-video {
        border-top: 5px solid transparent;
        border-left: 9px solid;
        border-left-color: $pl-element-color-secondary;
        border-bottom: 5px solid transparent;
        margin: 0 0.25rem 0.5rem 0.5rem;
        content: '';

        &.ti-media-gallery-bullet-is-active {
            border-left-color: $pl-element-color-primary;
        }
    }

    .ti-media-gallery-scroll-announcer {
        @include mix-hidden-visually;
    }

    .ti-media-gallery-scroll-container {
        display: flex;
        width: 100%;
        flex-wrap: nowrap;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        -ms-scroll-snap-type: mandatory;
        scrollbar-width: none; //to hide scroll bars in FF
        -ms-overflow-style: none; //to hide scroll bars in IE

        &:hover {
            cursor: zoom-in;
        }

        //to hide scroll bars
        &::-webkit-scrollbar {
            display: none;
        }

        .ti-media-gallery-scroll-item {
            box-sizing: border-box;
            min-width: 100%;
            scroll-snap-align: start;
        }
    }

    .ti-media-gallery-video-still-image {

        //Hide zoom icon on bottom right corner
        &:after {
            opacity: 0; //using opacity as content: none causes scroll animation to hiccup
        }

        ti-image {
            position: relative;
            cursor: pointer;

            &:before {
                @extend %video-playbutton;
                left: calc(50% - #{$polaris-space-8});
                top: calc(50% - #{$polaris-space-8});
                width: $polaris-space-16;
                height: $polaris-space-16;
            }
        }
    }

    // Image Carousel Dialog

    .ti-media-gallery-dialog-header {
        display: flex;
        flex-direction: row;
        align-items: center;

        span {
            text-decoration: none;
        }

        h2 {
            font-size: $polaris-font-size-5;
            line-height: $polaris-line-height-5;
            font-weight: $polaris-font-weight-light;
            margin: 0;
        }

        ti-file-download {
            margin: 0 0 0 auto;
            padding: $polaris-space-2;
            font-size: $polaris-font-size-2;

            a {
                display: flex;
                align-items: center;
                text-decoration: none;
                color: $pl-link-color-primary;
            }
        }
    }

    .ti-media-gallery-dialog-content {
        display: flex;
        flex-direction: column;
        position: relative;
        height: 100%;
    }

    .ti-media-gallery-dialog-multimedia {
        position: relative;
        display: flex;
        flex-shrink: 1;
        flex-grow: 1;
        justify-content: center;
        align-items: center;

        min-height: 100px;
        margin-bottom: $polaris-space-4;

        @include mix-for-sizes-down(phone) {
            align-items: initial;
        }

        a {
            color: $pl-link-color-primary;
            text-decoration: none;
        }

        img {
            width: 100%;
            height: 100%;
            background-position: 50% 50%;
            background-size: contain;
            background-repeat: no-repeat;
            background-origin: content-box;
            margin-left: auto;
            margin-right: auto;

            $missing-image-icon-size: 24px;

            &::before {
                position: absolute;
                inset: 50%;
                transform: translate(-12px, -12px);
                z-index: 2;
                height: $missing-image-icon-size;
                width: $missing-image-icon-size;
                background-size: $missing-image-icon-size;
                background-position: 50%;
                background-image: $polaris-svgIcon-imageFileBroken;
                background-repeat: no-repeat;
                color: transparent;
                content: '';
            }

            &::after {
                position: absolute;
                z-index: 1;
                inset: 0;
                min-height: $missing-image-icon-size;
                line-height: $missing-image-icon-size;
                background-color: $pl-container-background-color-primary-variant;
                color: transparent;
                content: '';
            }
        }

        &.is-image {
            display: block;
        }

        @supports (object-fit: scale-down) {
            img {
                object-fit: scale-down;
                width: auto;
                height: auto;
                max-height: 100%;
                width: 100%;
            }
        }

        .ti-media-gallery-dialog-multimedia-container {
            display: flex;
            height: 100%;
            width: 100%;
            justify-content: center;
            flex-direction: column;

            // For non-phone devices, less than 4/3 aspect ratio will orient the text-content to be side by side
            // with the Video
            @include mix-for-sizes-up(tablet) {
                @media (min-aspect-ratio: 4/3) {
                    flex-direction: row;
                    width: 100%;

                    .ti-media-gallery-dialog-multimedia-text-content {
                        margin-left: $polaris-space-8;
                        max-width: 40%;
                    }
                }
            }
        }

        .ti-media-gallery-dialog-multimedia-video-player {
            flex-grow: 2;
            margin-bottom: $polaris-space-4;
        }

        .ti-media-gallery-dialog-multimedia-video-description {
            @extend %polaris-font-style-paragraph-medium;
            margin-bottom: $polaris-space-6;
            margin-top: $polaris-space-2
        }

        .ti-media-gallery-dialog-multimedia-video-title {
            @extend %polaris-font-style-header-4;
        }
    }

    .ti-media-gallery-dialog-carousel {
        position: relative;
        display: flex;
        justify-content: center;
        flex: 0 0 auto;
        width: 100%;
        box-sizing: border-box;

        //Using style to hide so that dialog doesn't rerender
        @include mix-for-sizes-down(phone) {
            display: none;
        }
    }

    .ti-media-gallery-dialog-carousel-thumbnails {
        display: flex;
        flex-wrap: nowrap;
        overflow: hidden;
        padding: $polaris-space-2 $polaris-space-4;
        gap: $polaris-space-2;

        .ti-media-gallery-thumbnails-item {
            box-sizing: border-box;
            margin-top: 0;
            flex-grow: 0;
            flex-shrink: 0;
            width: 114px;

            &:first-child {
                margin-left: 0;
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }

    .ti-media-gallery-dialog-carousel-button {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        margin: 0 $polaris-space-2;
        opacity: 0;
        transition: opacity $polaris-animation-timing-fadeIn $polaris-animation-easing-smooth;
    }

    .ti-media-gallery-dialog-carousel-is-scrollable {

        &::before,
        &::after {
            display: block;
            opacity: 1;
            position: absolute;
            bottom: 1;
            z-index: 11505;
            content: '';
            width: 32px;
            height: 100%;
            pointer-events: none;
            transition: opacity $polaris-animation-timing-fadeIn $polaris-animation-easing-smooth;
        }

        &::before {
            left: 52px;
            background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0) 100%);
        }

        &::after {
            right: 52px;
            background-image: linear-gradient(270deg, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0) 100%);
        }

        .ti-media-gallery-dialog-carousel-button {
            opacity: 1;
            cursor: pointer;
        }

        &.ti-media-gallery-dialog-carousel-is-right {
            &::after {
                opacity: 0;
            }

            // display of right shadow
            .ti-media-gallery-dialog-carousel-button:last-child {
                opacity: 0.3;
                cursor: default;
            }

            // display of right arrow
        }

        &.ti-media-gallery-dialog-carousel-is-left {
            &::before {
                opacity: 0;
            }

            // display of left shadow
            .ti-media-gallery-dialog-carousel-button:first-child {
                opacity: 0.3;
                cursor: default;
            }

            // display of left arrow
        }
    }

    @keyframes carousel-fade-in {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    ::slotted([slot="download-label"]) {
        white-space: nowrap !important;
        font-size: $polaris-font-size-2;
        line-height: $polaris-line-height-2;
        margin-left: $polaris-space-2;
    }

    ::slotted([slot="media"]) {
        display: none;
        height: 100%;
    }
}

/* Play button overlay for video and video thumbnail */
%video-playbutton {
    position: absolute;
    content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' fill='white'%3E%3Cpath d='M 41 35 l 24 15 l -24 15 Z'%3E%3C/path%3E%3C/svg%3E");
    background-color: rgba(0, 0, 0, .5);
    z-index: 2;
    border-radius: 50%;
}
